const HOME_MAIN_DATA = {
    "id": "family_main",
    "category":"family",
    "name": "Home sweet home",
    "levels": [
        {
            "tileSize": 256,
            "size": 256,
            "fallbackOnly": true
        },
        {
            "tileSize": 512,
            "size": 512
        },
        {
            "tileSize": 512,
            "size": 1024
        },
        {
            "tileSize": 512,
            "size": 2048
        }
    ],
    "faceSize": 3840,
    "initialViewParameters": {
        "pitch": 0,
        "yaw": 0,
        "fov": 1.297391935482622
    },
    "linkHotspots": [
        {
            "yaw": -0.18400946135910345,
            "pitch": 0.02466837373458297,
            "rotation": 0,
            "pathname": "/family/tvs/tv/OLED65G29LA",
            "target": "family_tv",
            "category": "tvs",
            "targetCameraView": {
                "yaw": 0.21943838760407708,
                "pitch": 0.03399234334229462,
                "fov": 1
            },
            "targetCameraView2": {
                "yaw": -0.06983403346835004,
                "pitch": 0.15003453702875873,
                "fov": 1
            }
        },
        {
            "yaw": 3.1371327141354115,
            "pitch": 0.0863130335137523,
            "rotation": 0,
            "pathname": "/family/fridge/side_by_sides/GSXV90MCDE",
            "target": "family_fr",
            "category": "fridge",
            "targetCameraView": {
                "yaw": 0.2775142281923735,
                "pitch": 0.09072746761459882,
                "fov": 1.19
            },
            "targetCameraView2": {
                "yaw": -0.03908154865812463,
                "pitch": 0.23186754865708771,
                "fov": 1.19
            }
        }
    ],
    "infoHotspots": [],
};

export default HOME_MAIN_DATA;
